class Notification {
  static loaded = false;

  constructor(el) {
    this.container = el;
    this.duration = el.getAttribute('data-js-notification-duration');
    this.closeButton = el.querySelector('[data-js-close]');
    this.isClosingEvent = new CustomEvent('is-closing');

    this.init(el);
  }

  init(el) {
    el.setAttribute('aria-hidden', true);

    this.closeButton &&
      this.closeButton.addEventListener('click', () => this.close());

    this.container.addEventListener('close-notification', () => this.close());
    this.container.addEventListener('open-notification', () => this.open());
  }

  open() {
    this.container.setAttribute('aria-hidden', false);
  }

  close() {
    this.container.setAttribute('aria-hidden', true);
    this.container.dispatchEvent(this.isClosingEvent);
  }
}

export function init() {
  if (Notification.loaded) {
    return;
  }

  const toasts = Array.from(
    document.querySelectorAll('[data-js-notification]'),
  );

  toasts.length && toasts.forEach((el) => new Notification(el));

  Notification.loaded = true;
}
